import { createContext, ReactElement, useContext, useMemo } from 'react';
import { FieldValues, FormProvider, FormProviderProps } from 'react-hook-form';
import { ObjectSchema } from 'yup';

interface FormProviderRCProps {
  validation?: ObjectSchema<object>;
}

type Props<
  TFieldValues extends FieldValues,
  TContext = unknown,
  TTransformedValues extends FieldValues = TFieldValues,
> = FormProviderProps<TFieldValues, TContext, TTransformedValues> & {
  validation: ObjectSchema<object>;
};

const FormProviderRCDefaultValues: FormProviderRCProps = {
  validation: undefined,
};
export const FormProviderRCPropsContext = createContext<FormProviderRCProps>(
  FormProviderRCDefaultValues,
);

export const useFormProviderRCPropsContext = (): FormProviderRCProps => {
  return useContext<FormProviderRCProps>(FormProviderRCPropsContext);
};

export const FormProviderRc = <
  TFieldValues extends FieldValues,
  TContext = unknown,
  TTransformedValues extends FieldValues = TFieldValues,
>(
  props: Props<TFieldValues, TContext, TTransformedValues>,
): ReactElement<Props<TFieldValues, TContext, TTransformedValues>> => {
  const { validation, ...rest } = props;

  const validationMemo = useMemo(() => ({ validation }), [validation]);

  return (
    <FormProvider {...rest}>
      <FormProviderRCPropsContext.Provider value={validationMemo}>
        {props.children}
      </FormProviderRCPropsContext.Provider>
    </FormProvider>
  );
};
